// Texty časové osy doručení a zvláštních závozů (deliveryTimeline.js).
// Dny v týdnu jsou sdílené z locale dispatchEta.js.
import D from './dispatchEta.js';

export default {
  days: D.days,
  today: D.today,
  tomorrow: D.tomorrow,
  /** štítek dopravce vedle termínu („s GLS") */
  withCarrier: (carrier) => 's ' + carrier,
  fastest: 'Nejrychlejší',
  /** věta GLS soboty v den expedice; `cutoff` = dnešní uzávěrka („14:30") */
  satPromoToday: (cutoff) => 'Objednejte do ' + cutoff + ' a s GLS máte balík už zítra, v sobotu ',
  satPromoLater: 'Odešleme v pátek a s GLS máte balík už v sobotu ',
  sunPromoToday: 'Objednejte dnes do půlnoci, odešleme v neděli a s PPL máte balík už v pondělí ',
  sunPromoLater: 'Objednejte do sobotní půlnoci, odešleme v neděli a s PPL máte balík už v pondělí ',
  orderSunToday: 'dnes do půlnoci',
  orderSunLater: 'do sobotní půlnoci',
  /** krok „Objednáte" v den expedice („dnes do 14:30") */
  orderToday: (cutoff) => 'dnes do ' + cutoff,
  orderMidnight: 'dnes do půlnoci',
  shipToday: 'ještě dnes',
  /** rozmezí termínu doručení („30. 9. – 1. 10.", `shipping.deliverySpanDays` > 0) */
  range: (from, to) => from + ' – ' + to,
  /** odpočet „2 h 05 min" */
  hours: 'h',
  minutes: 'min',
};
